<template>
  <div v-show="!hidden" class="patrol-problem-menu"
    @mousedown="startDrag" 
    @wheel.stop
    @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')">
    <!-- 关闭按钮 -->
    <button class="close-button" @click="$emit('closePatrolProblem')">×</button>
    <!-- 标题 -->
    <h2 class="menu-title">{{ title }}({{ problemListInfo?problemListInfo.YQBH + "," + problemListInfo.XCCX: ""}})</h2>
    <!-- 问题显示区域 -->
    <div class="problem-container">
      <!-- 这里可以添加显示问题的逻辑 -->
      <template v-if="problemListInfo&&problemListInfo.problemList&&problemListInfo.problemList.length > 0">
        <div class="problem-sm"
          v-for="(problem,row) in problemListInfo.problemList" 
          :key="row">
          <!-- 这里可以根据实际情况展示问题的具体内容 -->
          问题{{ row + 1 }}:大棚编号：{{ problem.DPBH }}，巡查日期：{{problem.XCRQ}},问题类型：{{ problem.WTLX }}，问题描述：{{ problem.WTMS }}
          <img v-for="(photo,row) in problem.TPBH" :key="row" :src="photo" alt="问题照片" async
            @click="toggleZoom(photo)"
            :class="{ zoomed: currentZoomedPhoto === photo }"
          />     
        </div>
           
      </template> 
      <template v-else>
        未有持续关注问题和重点问题。
      </template>     
    </div>
    <!-- 遮罩层，用于在放大时覆盖背景 -->
    <div 
      v-if="currentZoomedPhoto" 
      class="zoom-overlay" 
      @click="toggleZoom(null)"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'PatrolProblem',
  props: {
    title: {
      type: String,
      default: '巡查问题'
    },
    problemListInfo: {
      type: Object,
      default: null
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      // 记录当前放大的问题（这里假设也有放大需求）
      currentZoomedPhoto: null 
    };
  },
  methods: {
    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.offsetX = this.$el.offsetLeft;
      this.offsetY = this.$el.offsetTop;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.$el.style.left = `${this.offsetX + dx}px`;
        this.$el.style.top = `${this.offsetY + dy}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    // 切换问题放大状态
    toggleZoom(photo) {
      this.currentZoomedPhoto = photo === this.currentZoomedPhoto ? null : photo;
    }
  }
};
</script>

<style scoped>
.patrol-problem-menu {
  width: 40%;
  top: 25vh;
  left: 25vw;
  position: fixed;
  z-index: 1002;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
  padding: 10px;
  max-height: 80vh;
  /* 防止父容器出现滚动条 */
  overflow: hidden; 
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1004;
}

.menu-title {
  background-color: #e0e0e0;
  padding: 5px;
  margin: -10px -10px 10px -10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  position: relative;
  top: 0;
  z-index: 1003;
}

.problem-container {
  /* 重新计算高度，减去标题栏和可能的内边距 */
  height: 60vh; 
  /* 当内容超出容器时，垂直方向显示滚动条 */
  overflow-y: auto; 
  /* 当内容超出容器时，水平方向显示滚动条 */
  overflow-x: auto; 
  position: relative;
}

.problem-sm{
    font-weight: bold;
    text-align: left;
    font-size: 14px;
}

img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
}

/* 放大后的照片样式 */
img.zoomed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.2); 
  z-index: 1006;
  max-width: 80vw;
  max-height: 80vh;
}

.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1004;
}
</style>
